<template>
  <div class="container">
    <section class="article-search">
      <div class="search-wapper">
        <h3><span>—</span> 检索分析 <span>—</span></h3>
        <div class="searchLeft flex">
          <div class="inputDiv flex">
            <el-input v-model="keyword" clearable @keyup.enter.native="toTrendSearch" placeholder="请输入技术主题词"></el-input>
            <span class="search-span" @click="toSearch"><i class="el-icon-search"></i>搜索</span>
            <div @click="toTrendSearch" class="search-btn"><img src="../../assets/images/fenxi-icon.png" />分析</div>
          </div>
        </div>
      </div>
    </section>
    <section class="wapper w1200">
      <div class="page4">
        <h3>热门概念</h3>
        <div class="page4-main">
          <span :class="{ checked: hotIndex == index }" v-for="(item, index) in hotList" :key="index" @click="toHotSearch(item, index)">{{ item }}</span>
        </div>
      </div>
      <p v-if="!keywordFlag" class="wapper-text">输入检索词,查询更多内容~</p>
      <!-- <a-button type="primary">加载</a-button> -->

      <!-- <a-tabs>
        <a-tab-pane key="1" tab="Tab 1">Content of Tab Pane 1</a-tab-pane>
        <a-tab-pane key="2" tab="Tab 2">Content of Tab Pane 2</a-tab-pane>
        <a-tab-pane key="3" tab="Tab 3">Content of Tab Pane 3</a-tab-pane>
      </a-tabs> -->
      <!-- 技术概念 -->

      <!-- 技术概念 -->
      <div class="page1" v-loading="loading" v-if="keywordFlag && conceptList.length > 0">
        <h3>技术概念</h3>
        <div class="page1-main">
          <el-tabs v-model="editableTabsValue" @tab-click="handleClickTab" ref="tabs">
            <el-tab-pane v-for="(item, index) in conceptList" :key="index" :label="item.name" :name="item.name" lazy>
              <p class="page1-load" v-if="descLoading">技术概念解析<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
              <div v-if="conceptVal && !descLoading" class="content">
                <typewriter :text="conceptVal" :speed="15"></typewriter>
              </div>
            </el-tab-pane>
          </el-tabs>
          <p class="tips" v-if="conceptList.length > 0"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
        </div>
      </div>
      <!-- 数据概览 -->
      <div class="page2" v-loading="analyLoading" v-if="keywordFlag">
        <h3>数据概览</h3>
        <div class="page2-main">
          <ul>
            <li @click="toList('1')">
              <img src="../../assets/images/lunwen.png" alt="" />
              <div class="page2-right">
                <p class="title">论文数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ lunwenNum }}</p>
              </div>
            </li>
            <li @click="toList('2')">
              <img src="../../assets/images/xuezhe.png" alt="" />

              <div class="page2-right">
                <p class="title">作者数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ zuozheNum }}</p>
              </div>
            </li>
            <li @click="toList('3')">
              <img src="../../assets/images/jigou.png" alt="" />
              <div class="page2-right">
                <p class="title">机构数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ jigouNum }}</p>
              </div>
            </li>
            <li @click="toList('4')">
              <img src="../../assets/images/qikan.png" alt="" />

              <div class="page2-right">
                <p class="title">期刊数量 <i class="el-icon-arrow-right"></i></p>
                <p class="num">{{ qikanNum }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 研究趋势 -->
      <div class="page3" v-loading="themeLoading" v-show="keywordFlag">
        <h3>研究趋势</h3>
        <div class="page3-main" v-show="themeData">
          <CategoryEcharts :themeData="themeData" :cateWidth="1160" @category-event="handleCategoryData"></CategoryEcharts>
        </div>
        <el-tabs v-model="activeName" v-if="themeData">
          <el-tab-pane label="概念解读" name="first">
            <div class="analysis-class">
              <p class="analysis-load" v-if="analysisLoading">概念解读<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
              <typewriter v-if="analysisInfo && !analysisLoading" :text="analysisInfo" :speed="15"></typewriter>
              <p class="analysis-tips"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
            </div>
          </el-tab-pane>
          <el-tab-pane label="使用说明" name="second">
            <div class="analysis-second">
              <h5>计算逻辑说明</h5>
              <p>以时间序列为基础，逐年统计论文数量、论文作者数量和论文所属机构数量，并形成一定时间范围内的趋势图。</p>
              <h5>图表使用说明</h5>
              <p>
                <span>折线图：</span
                >折线图可以清晰地展示数据随时间或其他变量的变化趋势。通过观察折线的上升或下降趋势，可以快速了解数据的增长、下降或波动情况。多条折线放在同一个图表中，可以直观地比较它们的趋势和关系，帮助观察者更好地理解数据之间的差异和相似性。通过观察折线的走势和模式，可以推测未来的发展方向和可能的
              </p>
            </div>
          </el-tab-pane>
        </el-tabs>
        <div class="noData" v-if="!themeData">
          <img src="../../assets/images/noData.png" />
        </div>
      </div>
      <div class="page5">
        <h3>研究热点</h3>
        <div class="page5-tab">
          <div class="page5-tab-item" @click="handleWordTab(1)">
            <img v-if="wordTabIndex != 1" src="../../assets/images/wordcloud.png" alt="" />
            <img v-if="wordTabIndex == 1" src="../../assets/images/wordcloud-checked.png" alt="" />
          </div>
          <!-- <div class="page5-tab-item" @click="handleWordTab(4)">
            <img v-if="wordTabIndex != 4" src="../../assets/images/juzhentu.png" alt="" />
            <img v-if="wordTabIndex == 4" src="../../assets/images/juzhentu-checked.png" alt="" />
          </div> -->
          <div class="page5-tab-item" @click="handleWordTab(2)">
            <img v-if="wordTabIndex != 2" src="../../assets/images/zhuzhuangtu.png" alt="" />
            <img v-if="wordTabIndex == 2" src="../../assets/images/zhuzhuangtu-checked.png" alt="" />
          </div>
          <div class="page5-tab-item" @click="handleWordTab(3)">
            <img v-if="wordTabIndex != 3" src="../../assets/images/table.png" alt="" />
            <img v-if="wordTabIndex == 3" src="../../assets/images/table-checked.png" alt="" />
          </div>
        </div>
        <wordcloud v-if="wordcloudData.length > 0 && wordTabIndex == 1" :wordcloudData="wordcloudData" @wordcloud-event="handlewordCloud"></wordcloud>
        <template v-if="wordTabIndex == 2"> <zhuzhuangtu v-show="wordcloudData.length > 0" :cateWidth="1160" :wordcloudData="wordcloudData" @wordcloud-event="handlewordCloud"></zhuzhuangtu> </template>
        <template v-if="wordTabIndex == 3">
          <tableData v-if="wordcloudData.length > 0" :wordcloudData="wordcloudData"></tableData>
        </template>

        <el-tabs v-model="page5Active" v-if="wordcloudData.length > 0">
          <el-tab-pane label="图表解读" name="first">
            <div class="page5_first" :class="{ page5_min90: page5Word }">
              <div class="analysis-class" v-if="page5Word">
                <p class="analysis-load" v-if="!hotwordLoading">图表解读<img class="rotating-image" src="../../assets/images/loading_s.svg" /></p>
                <typewriter v-if="hotWordsInfo && hotwordLoading" :text="hotWordsInfo" :speed="15"></typewriter>
                <p class="analysis-tips"><i class="el-icon-info"></i>以上内容为AI生成，不代表开发者立场</p>
              </div>
              <!-- 遮罩层 -->
              <div class="mask" v-if="!page5Word">
                <div class="mask_airead">
                  <img src="../../assets/images/mask_airead.png" />
                  <span @click="showPage5Word"><img src="../../assets/images/mask_icon.png" alt="" /><small>AI生成图表解读</small></span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="使用说明" name="second">
            <div class="analysis-second">
              <h5>计算逻辑说明</h5>
              <p>根据从论文中抽取到的技术主题词，逐篇统计出现特定技术主题词的论文数量，并利用可视化图表更直观地展示论文中的技术热点和关键词分布。</p>
              <h5>图表使用说明</h5>
              <p><span>词云图：</span>词云图可以将文本中出现的关键词按照出现频率大小的不同展示不同的字体大小和颜色，直观地呈现文本的关键内容，帮助观察者快速发现文本中的热门话题和关注点。</p>
              <!-- <p><span>矩阵树图：</span>矩阵树图可以将文本中出现的关键词按照出现频率的大小展示不同矩形面积的色块，直观地呈现文本的占比关系和关键内容，帮助观察者快速发现文本中的热门话题和关注点。</p> -->
              <p><span>柱状图：</span>柱状图通过按照数量或频率的大小对不同类别或变量进行排序，并将数据以垂直柱状条的形式表示，可以清晰地展示每个类别或变量的大小顺序和频率差异。观察者可以直观地比较它们之间的差异，理解数据的相对大小和排行，快速识别出数据中的重点和关键信息。</p>
            </div>
          </el-tab-pane>
        </el-tabs>

        <div class="noData" v-if="wordcloudData.length == 0">
          <img src="../../assets/images/noData.png" />
        </div>
      </div>
    </section>

    <!-- <span v-continuous-output="text"></span> -->
  </div>
</template>

<script>
import CategoryEcharts from "@/components/categoryEcharts.vue";
import typewriter from "@/components/typewriter.vue";
import wordcloud from "@/components/wordcloud.vue";
import zhuzhuangtu from "@/components/zhuzhuangtu.vue";
import tableData from "./tableData.vue";

export default {
  components: {
    CategoryEcharts,
    typewriter,
    wordcloud,
    zhuzhuangtu,
    tableData,
    // "a-tabs": Tabs.TabPane, // 注意这里的别名 a-tabs 是为了与 Ant Design Vue 的默认用法保持一致，实际上你应该这样使用： 'a-tab-pane': Tabs.TabPane, 'a-tabs': Tabs, 但为了示例清晰，这里分开写。
    // "a-tab-pane": Tabs.TabPane, // 直接引入 TabPane 并使用别名 a-tab-pane
  },
  data() {
    return {
      loading: false,
      tabIndex: 0,
      keyword: "",
      keywordFlag: false,
      conceptList: [], //技术概念tab
      editableTabsValue: "", //选中的值
      conceptVal: "", //选中的描述
      conceptId: "", //选中的id
      descLoading: false, //点击tab时的 loading
      analyLoading: false, //数据概览loading
      themeLoading: false, //研究趋势loading
      analysisList: [], //数据概览列表
      themeData: null, //趋势
      lunwenNum: 0,
      jigouNum: 0,
      zuozheNum: 0,
      qikanNum: 0,

      hotList: [],
      analysisInfo: "",
      activeName: "first",
      analysisLoading: false,
      analysisIndex: 0,

      hotIndex: "-1",

      // 研究热点 词云图数
      wordcloudData: [],
      wordTabIndex: 1,

      page5Active: "first",
      page5Word: false,
      hotWordsInfo: "",
      hotwordLoading: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.listenerScroll, true);
    this.getHotWord();
    if (sessionStorage.getItem("trend_word")) {
      this.keyword = sessionStorage.getItem("trend_word");
      this.keywordFlag = true;
      this.loading = true;
      this.analyLoading = true;
      this.themeLoading = true;
      this.getConceptList();
    }
  },
  methods: {
    getHotWord() {
      this.$http({
        url: "api/v1/concept/level",
        method: "get",
      }).then(res => {
        this.hotList = res.data;
      });
    },
    toHotSearch(val, index) {
      this.hotIndex = index;
      this.keyword = val;
      this.toTrendSearch();
    },
    toSearch() {
      if (this.keyword.trim()) {
        sessionStorage.setItem("trend_word", this.keyword);
      } else {
        if (sessionStorage.getItem("trend_word")) {
          this.keyword = sessionStorage.getItem("trend_word");
        } else {
          this.$message.error("检索分析内容不能为空,请输入技术主题词");
          this.keywordFlag = false;
          return;
        }
      }
      let _url = this.$router.resolve({
        path: "/trendList",
        query: { type: 1 },
      });
      window.open(_url.href, "_self");
    },
    toTrendSearch() {
      if (this.keyword.trim()) {
        this.keywordFlag = true;
        sessionStorage.setItem("trend_word", this.keyword);
      } else {
        if (sessionStorage.getItem("trend_word")) {
          this.keyword = sessionStorage.getItem("trend_word");
        } else {
          this.$message.error("检索分析内容不能为空,请输入技术主题词");
          this.keywordFlag = false;
          return;
        }
      }

      this.loading = true;
      this.analyLoading = true;
      this.themeLoading = true;
      this.getConceptList();
    },
    handleClickTab(tab) {
      this.wordcloudData = [];
      this.themeData = null;
      this.descLoading = true;
      this.editableTabsValue = this.conceptList[tab.index].name;
      this.conceptId = this.conceptList[tab.index].conceptId;
      this.page5Word = false;
      this.getAnalysis();
      this.getThemeData();
      this.getWordCloudData();
      setTimeout(() => {
        this.getDescription();
      }, 1200);
    },
    // tab列表
    getConceptList() {
      this.$http({
        url: "api/v1/concept/list?keywords=" + this.keyword,
        method: "get",
      }).then(res => {
        this.loading = false;
        this.$nextTick(() => {
          this.conceptList = res.data;
          if (this.conceptList.length > 0) {
            setTimeout(() => {
              this.isRightArrow();
            }, 300);
            this.editableTabsValue = this.conceptList[0].name;
            this.conceptId = this.conceptList[0].conceptId;
            this.descLoading = true;
            this.getAnalysis();
            this.getThemeData();
            this.getWordCloudData();
            setTimeout(() => {
              this.getDescription();
            }, 1200);
          } else {
            this.loading = false;
            this.analyLoading = false;
            this.themeLoading = false;
            this.themeData = null; //趋势
            this.lunwenNum = 0;
            this.jigouNum = 0;
            this.zuozheNum = 0;
            this.qikanNum = 0;
          }
        });
      });
    },
    // 动态显示隐藏左右箭头
    isRightArrow() {
      this.$nextTick(() => {
        // 找出下面对应的nav实例
        function findTabNavVue(vueStance) {
          const childrens = vueStance.$children;
          const len = childrens.length;
          for (let i = 0; i < len; i++) {
            const child = childrens[i];
            if (child.scrollNext) return child;
          }
        }
        const navVue = findTabNavVue(this.$refs.tabs);
        if (navVue.$el.querySelector(".el-tabs__nav-prev")) {
          navVue.$el.querySelector(".el-tabs__nav-prev").style.visibility = "hidden";
        }
        if (navVue.scrollable) {
          let nextNode;
          let nextNode2;
          navVue.$watch("navOffset", function (currentOffset) {
            var navSize = this.$refs.nav["offsetWidth"];
            var containerSize = this.$refs.navScroll["offsetWidth"];
            const isRight = navSize - currentOffset <= containerSize;
            const isLeft = currentOffset == 0;
            nextNode = nextNode ? nextNode : navVue.$el.querySelector(".el-tabs__nav-next");
            nextNode.style.visibility = isRight ? "hidden" : "";

            nextNode2 = nextNode2 ? nextNode2 : navVue.$el.querySelector(".el-tabs__nav-prev");
            nextNode2.style.visibility = isLeft ? "hidden" : "";
          });
        }
      });
    },
    // 获取描述
    getDescription() {
      this.$http({
        url: "api/v1/concept/message?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.descLoading = false;
        this.conceptVal = res.data;
      });
    },
    // 数据概览
    getAnalysis() {
      this.$http({
        url: "api/v1/concept/analysis?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.analyLoading = false;
        this.analysisList = res.data;
        this.analysisList.forEach(element => {
          if (element.conceptType == 10) {
            this.lunwenNum = element.count;
          }
          if (element.conceptType == 20) {
            this.zuozheNum = element.count;
          }
          if (element.conceptType == 30) {
            this.jigouNum = element.count;
          }
          if (element.conceptType == 40) {
            this.qikanNum = element.count;
          }
        });
      });
    },
    //研究趋势
    getThemeData() {
      this.$http({
        url: "api/v1/concept/area/trend?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.themeLoading = false;
        if (res.data.conceptTrendTypeBoList && res.data.conceptTrendTypeBoList.length > 0 && res.data.yearList && res.data.yearList.length > 0) {
          this.themeData = res.data;
        } else {
          this.themeData = null;
        }

        // 概念解读
        this.analysisLoading = true;
        this.scrollTop = 0;
        this.getAnalysisInfo();
      });
    },
    // 监控滚动条 滑到某个位置再开始显示概念解读
    listenerScroll() {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scrollTop > 450) {
        setTimeout(() => {
          this.analysisLoading = false;
        }, 500);
      }
    },
    // 概念解读
    getAnalysisInfo() {
      this.$http({
        url: "api/v1/concept/area/trend/analysis?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.analysisInfo = res.data;
      });
    },
    toList(val) {
      let _url = this.$router.resolve({
        path: "/trendList",
        query: { type: val, value: this.editableTabsValue, conceptId: this.conceptId },
      });
      window.open(_url.href, "_self");
    },
    //研究热点
    getWordCloudData() {
      this.$http({
        url: "api/v1/concept/hot/keyword?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.wordcloudData = res.data;
        this.wordcloudData.forEach((element, index) => {
          this.wordcloudData[index].value = element.count;
          this.wordcloudData[index].name = element.word;
        });
      });
    },
    handlewordCloud(val) {
      let _url = this.$router.resolve({
        path: "/trendList",
        query: { type: 1, value: this.editableTabsValue, conceptId: this.conceptId, words: val.data.name ? val.data.name : val.name },
      });
      window.open(_url.href, "_self");
    },
    handleCategoryData(val) {
      // let _url = this.$router.resolve({
      //   path: "/trendList",
      //   query: { type: val.seriesIndex + 1, value: this.editableTabsValue, conceptId: this.conceptId, years: val.name },
      // });
      // window.open(_url.href, "_blank");
    },
    // 热点里的图标切换事件
    handleWordTab(val) {
      this.wordTabIndex = val;
    },
    showPage5Word() {
      this.page5Word = true;
      this.$http({
        url: "api/v1/concept/hot/keyword/analysis?conceptId=" + this.conceptId,
        method: "get",
      }).then(res => {
        this.hotWordsInfo = res.data;
        setTimeout(() => {
          this.hotwordLoading = true;
        }, 1500);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 154px);
  .article-search {
    width: 100%;
    height: 240px;
    background: url("../../assets/images/search_bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    .search-wapper {
      width: 1200px;
      margin: 0 auto;
      position: relative;
    }
    h3 {
      text-align: center;
      font-weight: normal;
      font-size: 26px;
      font-family: "宋体";
      span {
        color: #cccccc;
      }
    }
    .searchLeft {
      border: 1px solid #cccccc;
      width: 840px;
      height: 48px;
      background: #fff;
      margin: 0 auto;
      margin-top: 30px;
      position: relative;
      ::v-deep .el-input__inner {
        border: none;
        height: 48px;
        background: none;
        border-radius: 0;
      }

      .inputDiv {
        align-items: center;
        flex: 1;
        background: #fff;
        ::v-deep .el-input {
          flex: 1;
        }
        .search-span {
          margin-right: 30px;
          cursor: pointer;
          color: #666;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            right: -15px;
            top: 50%;
            margin-top: -13px;
            height: 26px;
            width: 1px;
            background: #ccc;
          }
          i {
            margin-right: 5px;
          }
        }
        .search-btn {
          cursor: pointer;
          margin-right: 4px;
          width: 80px;
          height: 40px;
          background: #2d8cf0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          img {
            width: 28px;
          }
        }
      }
    }
  }
  .wapper {
    .wapper-text {
      text-align: center;
      font-size: 16px;
      color: #999999;
      margin: 30px 0;
      background: #fff;
      padding-top: 100px;
      min-height: calc(100vh - 450px);
    }

    .rotating-image {
      animation: rotate 1s linear infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    .page4 {
      span {
        margin-right: 25px;
        line-height: 30px;
        cursor: pointer;
        display: inline-block;
        &:hover {
          color: #2d8cf0;
        }
      }
      .checked {
        color: #2d8cf0;
      }
    }
    .page1,
    .page2,
    .page3,
    .page4,
    .page5 {
      margin-top: 20px;
      padding: 20px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 4px 0 rgba(39, 42, 46, 0.1);
      h3 {
        height: 62px;
        margin: -20px -20px 0;
        padding: 0 20px;
        color: #202224;
        font-size: 18px;
        line-height: 62px;
        background: url("../../assets/images/trend_h3.png") no-repeat 0;
        background-size: 240px 100%;
      }
    }

    .page1 {
      .page1-main {
        min-height: 100px;
        .tabs-wrap {
          position: relative;
          display: flex;
          flex: auto;
          overflow: hidden;
          white-space: nowrap;
          transform: translate(0);
        }
      }
      ::v-deep .el-tabs__item {
        color: #636870;
        cursor: pointer;
        position: relative;
        font-size: 16px;
      }
      ::v-deep .is-active {
        color: #2d8cf0;
        font-size: 20px;
        font-weight: bold;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      ::v-deep .el-tabs__nav-wrap {
        padding: 0 25px;
        > span {
          font-size: 20px;
          line-height: 39px;
        }
      }
      ::v-deep .content {
        color: #636870;
        padding: 20px 0;
        font-size: 14px;
        line-height: 22px;
      }
      ::v-deep .el-tabs__header {
        margin: 0;
      }
      .page1-load {
        font-size: 14px;
        color: #636870;
        padding: 20px 0;
        display: flex;
        align-items: center;
        img {
          margin-left: 5px;
        }
      }
      .tips {
        color: #969ca4;
        font-size: 12px;
        text-align: right;
        i {
          margin-right: 5px;
        }
      }
    }
    .page2 {
      ul {
        display: flex;
        justify-content: space-between;
        li {
          display: flex;
          align-items: center;
          cursor: pointer;
          img {
            width: 40px;
            height: 40px;
            margin-right: 15px;
          }
          .page2-right {
            .title {
              color: #4e5969;
              margin-bottom: 5px;
            }
            .num {
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }
    .page3,
    .page5 {
      margin-bottom: 20px;
      .page3-main {
        height: 340px;
        width: 100%;
      }
      ::v-deep .el-tabs__item {
        font-size: 16px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      .analysis-class {
        color: #636870;
        font-size: 15px;
        line-height: 25px;
        .analysis-load {
          display: flex;
          align-items: center;
          img {
            margin-left: 5px;
          }
        }
        .analysis-tips {
          text-align: right;
          color: #969ca4;
          font-size: 12px;
          margin-top: 5px;
          i {
            margin-right: 5px;
          }
        }
      }
      .analysis-second {
        h5 {
          font-size: 16px;
          margin-bottom: 10px;
        }
        p {
          margin-bottom: 15px;
          color: #636870;
          font-size: 15px;
          line-height: 25px;
          span {
            color: #333;
            font-weight: bold;
          }
        }
      }
    }
    .page5 {
      .page5-tab {
        display: flex;
        img {
          cursor: pointer;
        }
      }
      ::v-deep .el-tabs__item {
        font-size: 16px;
      }
      ::v-deep .el-tabs__nav-wrap::after {
        height: 1px;
      }
      .page5_min90 {
        min-height: 90px !important;
      }
      .el-tabs {
        margin-top: 20px;
      }
      .page5_first {
        position: relative;
        min-height: 180px;
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          img {
            width: 100%;
          }
          .mask_airead {
            position: relative;
            span {
              position: absolute;
              top: 50%;
              left: 50%;
              display: flex;
              grid-gap: 8px;
              gap: 8px;
              align-items: center;
              justify-content: space-between;
              padding: 8px 16px;
              background: #fff;
              border: 1px solid #dcdcdc;
              border-radius: 6px;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.02);
              transform: translate(-50%, -50%);
              cursor: pointer;
              &:hover {
                color: #2d8cf0;
                border: 1px solid#2d8cf0;
                small {
                  color: #2d8cf0;
                }
              }
              img {
                width: 24px;
                height: 24px;
              }
              small {
                height: 22px;
                color: #202224;
                font-weight: 400;
                font-size: 16px;
                line-height: 22px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
